import { colors } from '@material-ui/core';

export default {
    root: {
        '&:nth-child(even)': {
            backgroundColor: '#F8F9FD'
        }
    }
};
